<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show v-if="models.project"
                :id="id"
                :models="models"
                :infos="infos"
                model-def="projects"
                no-edit
                topClass=""
            ></show>

            <v-col class="pa-0 pb-4">
                <project-kpi
                    :id="id"
                ></project-kpi>
            </v-col>

            <v-row class="pa-0 ma-0">
                <tasks-distribution
                    :id="id"
                ></tasks-distribution>
                <tasks-duration
                    :id="id"
                ></tasks-duration>
            </v-row>

            <v-row class="ma-0 pt-3" v-if="$store.getters.checkModulePermissions('timecards')">
                <timecards-user v-if="$store.getters.checkModulePermissions('timecards')"
                    :id="id"
                ></timecards-user>

                <v-col cols="12" sm="12" :lg="$store.getters.checkModulePermissions('timecards') ? 8 : 12" class="pa-0 pb-1">
                    <belongstomany-show v-if="models.project && models.project.products"
                        :height="$store.getters.checkModulePermissions('timecards') ? 410 : undefined"
                        :class="setClass()"
                        :collection="models.project.products"
                        :headers="headersProducts"
                        :flag="productsGroup"
                        title="Prodotti"
                        downloadCSV>
                        <template slot="table-footer">
                            <v-row class="ma-0 pa-0 justify-center">
                                <v-col class="col-lg-3 col-md-4 col-sm-4 col-xs-6 px-0">                            
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mdi-currency-eur</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Imponibile Prodotti</v-list-item-title>
                                                <v-list-item-subtitle>{{ productSubtotal | currency }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-col class="col-lg-3 col-md-4 col-sm-4 col-xs-6 px-0">                            
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mdi-currency-eur</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Costi Prodotti</v-list-item-title>
                                                <v-list-item-subtitle>{{ totalProductCost | currency }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-col class="col-lg-3 col-md-4 col-sm-4 col-xs-6 px-0">                            
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">local_offer</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Quantità Prodotti</v-list-item-title>
                                                <v-list-item-subtitle>{{ totalQuantity }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </template>
                    </belongstomany-show>
                </v-col>
            </v-row>
            <v-col class="pa-0 pt-4 pb-3" v-if="$store.getters.checkSettings('products_association_task')">
                <project-products v-if="models.project && models.project.products"
                    :project="models.project"
                ></project-products>
            </v-col>
            
            <v-col class="pa-0 pt-3" v-if="$store.getters.checkModulePermissions('timecards')">
                <crud
                    title='Timecard'
                    action-icon='alarm'
                    model-def='timecards'
                    :sub-filters="subFilters"
                    action-position='fixed'
                    :position-left="true"
                    :position-right="false"
                    direction="right"
                ></crud>
            </v-col>

            <activities
                class="pt-3"
                model-class="project"
                model-def="projects"
                :model-id="id"
            ></activities>

            <dms-uploader class="mt-4"
                :id="id"
                attachable-type="project"
            ></dms-uploader>

            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-fab-transition>
                        <v-btn
                            v-on="{ ...tooltip }"
                            @click.native="$eventBusUtility.goTo($router, 'projects-edit', models.project.id)"
                            color="primary"
                            dark
                            fixed
                            bottom
                            right
                            fab>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </template>
                <span>Modifica</span>
            </v-tooltip>

        </v-col>
    </v-row>
</template>

<script>

    import Activities from '@/components/common/Activities'
    import ProjectKpi from '@/components/modules/projects/ProjectKpi'
    import BelongstomanyShow from '@/components/common/BelongstomanyShow'
    import TasksDuration from '@/components/modules/projects/TasksDuration'
    import TimecardsUser from '@/components/modules/projects/TimecardsUser'
    import TasksDistribution from '@/components/modules/projects/TasksDistribution'
    import ProjectProducts from '@/components/modules/projects/ProjectProducts'

    export default {
        name: 'project',
        components: {
            Activities,
            ProjectKpi,
            TimecardsUser,
            TasksDuration,
            ProjectProducts,
            TasksDistribution,
            BelongstomanyShow,
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                subFilters: { projects: this.id },
                productsGroup: {label: 'Dividi', value: false},
                debounce: null,
                headersProducts: [
                    {
                        align: 'left',
                        value: 'name',
                        text: 'Prodotto',
                    },
                    {
                        align: 'left',
                        value: 'title',
                        text: 'Task/DDT',
                    },
                    {
                        align: 'left',
                        value: 'quantity',
                        text: 'Quantità'
                    },
                    {
                        align: 'left',
                        value: 'cost',
                        text: 'Costo',
                        type: 'currency'
                    },
                    {
                        align: 'left',
                        value: 'subtotal',
                        text: 'Imponibile',
                        type: 'currency'
                    },
                ],
            }
        },

        watch: {
            'productsGroup.value': function(val, oldVal) {
                if(this.debounce) {
                    clearTimeout(this.debounce)
                }
                this.debounce = setTimeout(this.initialize, 300)
            }
        },

        created() {
            this.initialize()
        },

        methods: {

            initialize() {
                this.axios.get('projects/' + this.id + '?group_products=' + this.productsGroup.value).then(response => {
                    this.models = response.data.models
                    this.infos = response.data.infos
                    this.$store.commit('endProgress')
                    this.load = true

                }, response => {
                    // error callback
                })
            },
            
            setClass() {
                if(!this.$store.getters.checkModulePermissions('timecards')) {
                    return 'pa-0'
                }
                if(this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
                    return 'pa-0 pl-2 pr-0'
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    return 'pa-0 pr-0 pt-4'
                }
                if(this.$vuetify.breakpoint.xs) {
                    return 'pa-0 pt-4'
                }
            },
        },

        computed: {

            productSubtotal() {
                return this.models.project.products ?  this.models.project.products.reduce((acc, product) => acc + parseFloat(product.subtotal), 0) : 0
            },

            totalQuantity() {
                return this.models.project.products ?  this.models.project.products.reduce((acc, product) => acc + product.quantity, 0).toFixed(2) : 0
            },

            totalProductCost() {
                return this.models.project.products ? this.models.project.products.reduce((acc, product) => acc + product.cost, 0) : 0
            },

            totalTaskCost() {
                return this.models.project.products ? this.models.project.duration.total_duration * (this.models.project.hourly_cost/60) : 0
            },

            budgetProgress() {
                if(this.models.project.budget) {
                    return (((this.productSubtotal + this.totalTaskCost)  * 100) / this.models.project.budget).toFixed(2)
                } else {
                    return 0
                }
            }
        },
    }
</script>
